import { Card, CardBody, Spinner } from '@heroui/react';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import SEOHead from '../components/SEOHead';
import { contentService } from '../services/contentService';
import { createSafeHtmlProps } from '../utils/htmlUtils';

const Legal: React.FC = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['content', 'legal'],
    queryFn: () => contentService.getContentPage('legal'),
  });
  const pageTitle = data?.title || 'Legal Information';
  const pageDescription =
    data?.summary || 'Review legal policies, terms, and privacy information.';

  if (isLoading) {
    return (
      <>
        <SEOHead title={pageTitle} description={pageDescription} />
        <div className='max-w-4xl mx-auto p-6'>
          <Spinner />
        </div>
      </>
    );
  }

  return (
    <>
      <SEOHead title={pageTitle} description={pageDescription} />
      <div className='max-w-5xl mx-auto p-6'>
        <h1 className='text-3xl font-bold mb-4'>
          {data?.title || 'Legal Information'}
        </h1>
        {data?.summary && <p className='text-gray-600 mb-6'>{data.summary}</p>}
        <Card>
          <CardBody>
            <div
              {...createSafeHtmlProps(data?.bodyHtml || '', 'prose max-w-none')}
            />
            {Array.isArray(data?.sections) && data.sections.length > 0 && (
              <div className='mt-6 space-y-6'>
                {data.sections
                  .sort((a: any, b: any) => (a.order || 0) - (b.order || 0))
                  .map((s: any, i: number) => (
                    <section key={i}>
                      {s.heading && (
                        <h2 className='text-xl font-semibold mb-2'>
                          {s.heading}
                        </h2>
                      )}
                      <div
                        {...createSafeHtmlProps(
                          s.bodyHtml || '',
                          'prose max-w-none'
                        )}
                      />
                    </section>
                  ))}
              </div>
            )}
          </CardBody>
        </Card>
      </div>
    </>
  );
};

export default Legal;
